// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".program-list{display:flex;flex-direction:column;gap:var(--spacing-4xl);margin-bottom:var(--spacing-6xl)}.program-list__item{display:grid;grid-template-columns:1fr;grid-gap:var(--grid-gap-mobile);gap:var(--grid-gap-mobile)}@media screen and (min-width:769px){.program-list__item{gap:var(--grid-gap-md);grid-template-columns:1fr 2fr}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
